import { type ContactRemoveInput, type ContactRemoveSuccess, Logger, toResponseError } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { useLocationCache } from '../location'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useReplaceLocation } from './replaceLocation'
import { useContactCache } from './cache'

const logger = new Logger('useRemoveContact')

export function useRemoveContact(): RemoveHookResponse<ContactRemoveInput> {
  logger.verbose('calling useRemoveContact')
  const replaceLocation = useReplaceLocation()
  const { removeItem } = useContactCache()
  const { replaceItem } = useLocationCache()
  const mutation = useTantalimMutation<ContactRemoveInput, ContactRemoveSuccess>({ url: '/contact/remove' })

  async function remove(input: ContactRemoveInput): Promise<void> {
    try {
      logger.verbose('starting remove')
      const { location } = await mutation.mutateAsync(input)
      const { locationId } = location
      replaceItem(locationId, location)
      replaceLocation({
        locationId,
        newLocation: location,
      })
      await removeItem(input)
      logger.verbose('done with remove')
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
